"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestroyOptionsSchema = void 0;
var zod_1 = require("zod");
exports.DestroyOptionsSchema = zod_1.z.object({ reason: zod_1.z.string().optional() }).optional();
//# sourceMappingURL=destroy-options.js.map